import { createGlobalStyle } from "styled-components";
import reset from './reset';
import fontface from './font-face';

export default createGlobalStyle`
    ${reset}
    ${fontface}
`;